import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "main-container",
  ref: "appRoot"
}
const _hoisted_2 = {
  key: 0,
  class: "dialog-bg"
}
const _hoisted_3 = {
  key: 1,
  class: "main-container",
  ref: "appRoot"
}
const _hoisted_4 = {
  key: 0,
  class: "toast-message-wrap"
}
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<audio muted id=\"audio1\"></audio><audio muted id=\"audio2\"></audio><audio muted id=\"audio3\"></audio><audio muted id=\"audio4\"></audio><audio muted id=\"audio5\"></audio><audio muted id=\"audio6\"></audio><div class=\"portrait-cover\"><div class=\"icon-rotate\"></div><div class=\"p-label\">請旋轉您的設備。<br>為了更好的顯示</div></div>", 7)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_msg_box_setting = _resolveComponent("msg-box-setting")!
  const _component_msg_box_avatar = _resolveComponent("msg-box-avatar")!
  const _component_msg_box_message = _resolveComponent("msg-box-message")!
  const _component_msg_box_password = _resolveComponent("msg-box-password")!
  const _component_msg_box_history = _resolveComponent("msg-box-history")!
  const _component_msg_box_rule = _resolveComponent("msg-box-rule")!
  const _component_app_loader = _resolveComponent("app-loader")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app-root", { mobile: _ctx.isMobile }]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.initSound && _ctx.initSound(...args)))
  }, [
    (_ctx.showMainView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_router_view),
          _createVNode(_Transition, { name: "fadein-out" }, {
            default: _withCtx(() => [
              (_ctx.hasVisibleDialog)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    (_ctx.showSettingDialogBox)
                      ? (_openBlock(), _createBlock(_component_msg_box_setting, { key: 0 }))
                      : _createCommentVNode("", true),
                    (_ctx.showAvatarDialog)
                      ? (_openBlock(), _createBlock(_component_msg_box_avatar, { key: 1 }))
                      : _createCommentVNode("", true),
                    (_ctx.showCancelConfirmMessage)
                      ? (_openBlock(), _createBlock(_component_msg_box_message, { key: 2 }))
                      : _createCommentVNode("", true),
                    (_ctx.showChangePasswordMsg)
                      ? (_openBlock(), _createBlock(_component_msg_box_password, { key: 3 }))
                      : _createCommentVNode("", true),
                    (_ctx.showRecordDialogBox)
                      ? (_openBlock(), _createBlock(_component_msg_box_history, { key: 4 }))
                      : _createCommentVNode("", true),
                    (_ctx.showRuleDialogBox)
                      ? (_openBlock(), _createBlock(_component_msg_box_rule, { key: 5 }))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ], 512))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, null, 512)),
    _createVNode(_Transition, { name: "fadein-out" }, {
      default: _withCtx(() => [
        (_ctx.toastMessageCounter > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("p", null, _toDisplayString(_ctx.toastMessage), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _hoisted_5,
    (_ctx.showLoading)
      ? (_openBlock(), _createBlock(_component_app_loader, { key: 2 }))
      : _createCommentVNode("", true)
  ], 2))
}